import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { loginSliceValue } from "../redux/reducers/loginSlice";
import { HashRouter, Routes, Route } from "react-router-dom";
import SessionTimeoutProvider from "../components/SessionTimeoutProvider";

// ClinicsScreen,
import {
  LoginScreen,
  HomeScreen,
  ClinicsNewScreen,
  RtmPlan,
  RtmTimeLogging,
  UsersScreen,
  ProvidersScreen,
  SecureFilesScreen,
  AdCampaignsScreen,
  AdStatisticsScreen,
  AdViewScreen,
  AppointmentsScreen,
  MyProfileScreen,
  PatientEnrollmentScreen,
  AppointmentsNewScreen,
  // ClinicDocumentsScreen,
  FeedbackScreen,
  CheckinsScreen,
  CheckinLobbyScreen,
  ShareFileDownloadScreen,
  FeedbackResultsScreen,
  RtmTemplateScreen,
  ResourcesNewScreen,
  PatientScreen,
  PlanPatientListScreen,
  AssociateClinic,
  PatientsDashboard,
  // RTMDashboard,
  BillingList,
  // RTMAddTemplateScreen,
} from "../pages";
import { Socket } from "socket.io-client";
import VideoState from "../pageComponents/VideoCall/context/VideoState";
import VideoCallScreen from "../pages/VideoCall";
import RTMDashboard from "../pageComponents/Dashboard/RTMDashboard";
import RTMBillingReportPage from "../pageComponents/RTMBillingReportPage/RTMBillingReportPage";
import PhysicianReportPage from "../pageComponents/PhysicianReportPage/PhysicianReportPage";

// const HomePage = () => {
//   const { loading, token, userDetails } = useSelector(loginSliceValue);

//   if (loading) return <Loader />;
//   return token && userDetails.result.role === 'Super Admin' ? <OrganizationsScreen /> : <HomeScreen />;
// };

interface NavigationPros {
  socket: Socket | null;
}

const Navigation: React.FC<NavigationPros> = ({ socket }) => {
  const { loading, userDetails } = useSelector(loginSliceValue);

  const isAuthenticated = !!userDetails?.token;
  const userRole = userDetails?.data?.user?.role;

  return (
    <HashRouter>
      <SessionTimeoutProvider>
        <VideoState socket={socket}>
          <Routes>
            <Route
              path="/login"
              element={isAuthenticated ? <HomeScreen /> : <LoginScreen />}
            />
            <Route path="/enrollment" element={<PatientEnrollmentScreen />} />
            <Route path="/share-file" element={<ShareFileDownloadScreen />} />
            <Route
              path="/"
              element={isAuthenticated ? <HomeScreen /> : <LoginScreen />}
            />
            <Route
              path="/my-profile"
              element={isAuthenticated ? <MyProfileScreen /> : <LoginScreen />}
            />
            <Route
              path="/make/:call/:type/:userId/:name/:socketId"
              element={
                isAuthenticated ? (
                  <VideoCallScreen socket={socket} />
                ) : (
                  <LoginScreen />
                )
              }
            />
            <Route
              path="/billing-list/page/:billingId"
              element={<RTMBillingReportPage />}
            />
            <Route
              path="/Patient/physician-report-page/:billingCycleId/"
              element={<PhysicianReportPage />}
            />

            {isAuthenticated && (
              <Fragment>
                {userDetails.data?.user.role === "admin" ? (
                  <Fragment>
                    <Route path="/clinics" element={<ClinicsNewScreen />} />
                    <Route
                      path="/associate-clinic/:clinicId"
                      element={<AssociateClinic />}
                    />
                    <Route path="/rtm-plan" element={<RtmPlan />} />
                    <Route
                      path="/rtm-time-logging"
                      element={<RtmTimeLogging />}
                    />
       
                    <Route
                      path="/users"
                      element={<UsersScreen socket={socket} />}
                    />
                    <Route
                      path="/ad-campaigns"
                      element={<AdCampaignsScreen />}
                    />
                    <Route
                      path="/ad-statistics"
                      element={<AdStatisticsScreen />}
                    />
                    <Route path="/view-campaign" element={<AdViewScreen />} />
                    <Route
                      path="/appointments"
                      element={<AppointmentsNewScreen />}
                    />
                    <Route path="/feedback" element={<FeedbackScreen />} />
                    <Route
                      path="/patient-feedback"
                      element={<FeedbackResultsScreen />}
                    />
                    <Route
                      path="/rtm-template"
                      element={<RtmTemplateScreen />}
                    />
                    {/* <Route path='/rtm-template-add' element={<RTMAddTemplateScreen />} /> */}
                    {/* Add path for resource */} */
                    {/* <Route path='/rtm-template' element={<RtmTemplateScreen/>} /> */}
                    <Route
                      path="/rtm-resource"
                      element={<ResourcesNewScreen />}
                    />
                    <Route
                      path="/secure-files"
                      element={<SecureFilesScreen />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "manager" ? (
                  <Fragment>
                    <Route
                      path="/users"
                      element={<UsersScreen socket={socket} />}
                    />
                    <Route path="/providers" element={<ProvidersScreen />} />
                    <Route
                      path="/appointments"
                      element={<AppointmentsScreen />}
                    />
                    <Route path="/check-ins" element={<CheckinsScreen />} />
                    <Route
                      path="/check-in-lobby"
                      element={<CheckinLobbyScreen />}
                    />
                    <Route path="/feedback" element={<FeedbackScreen />} />
                    <Route
                      path="/patient-feedback"
                      element={<FeedbackResultsScreen />}
                    />
                    {/* Add path for patient,chat,rtm-time-logging */}
                    {/* <Route path="/patients" element={<PatientsDashboard />} /> */}
                    <Route
                      path="/plan-patient-list"
                      element={<PlanPatientListScreen />}
                    />
              
                    <Route
                      path="/rtm-time-logging"
                      element={<RtmTimeLogging />}
                    />
                    <Route
                      path="/secure-files"
                      element={<SecureFilesScreen />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "clinician" ? (
                  <Fragment>
                    {/* Add path for patient,chat,rtm-time-logging */}
                    <Route
                      path="/patient"
                      element={<PatientScreen socket={socket} />}
                    />
                    <Route
                      path="/plan-patient-list"
                      element={<PlanPatientListScreen />}
                    />
   
                  </Fragment>
                ) : userDetails.data?.user.role === "rtmManager" ? (
                  <Fragment>
                    <Route
                      path="/patient"
                      element={<PatientScreen socket={socket} />}
                    />

                  </Fragment>
                ) : userDetails.data?.user.role === "rtmProvider" ? (
                  <Fragment>
                    <Route
                      path="/"
                      element={<PatientScreen socket={socket} />}
                    />
                    <Route
                      path="/patient"
                      element={<PatientScreen socket={socket} />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "receptionist" ? (
                  <Fragment>
                    <Route
                      path="/users"
                      element={<UsersScreen socket={socket} />}
                    />
                    <Route path="/providers" element={<ProvidersScreen />} />
                    <Route
                      path="/appointments"
                      element={<AppointmentsScreen />}
                    />
                    <Route path="/check-ins" element={<CheckinsScreen />} />
                    <Route
                      path="/check-in-lobby"
                      element={<CheckinLobbyScreen />}
                    />
                    {/* <Route path='/feedback' element={<FeedbackScreen />} /> */}
                    <Route
                      path="/patient-feedback"
                      element={<FeedbackResultsScreen />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "adAdmin" ? (
                  <Fragment>
                    <Route
                      path="/users"
                      element={<UsersScreen socket={socket} />}
                    />
                    <Route
                      path="/ad-campaigns"
                      element={<AdCampaignsScreen />}
                    />
                    <Route
                      path="/ad-statistics"
                      element={<AdStatisticsScreen />}
                    />
                    <Route path="/view-campaign" element={<AdViewScreen />} />
                    <Route
                      path="/secure-files"
                      element={<SecureFilesScreen />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "clinic" ? (
                  <Fragment>
                    <Route
                      path="/users"
                      element={<UsersScreen socket={socket} />}
                    />
                    <Route path="/providers" element={<ProvidersScreen />} />
                    <Route
                      path="/appointments"
                      element={<AppointmentsScreen />}
                    />
                    <Route path="/check-ins" element={<CheckinsScreen />} />
                    <Route
                      path="/check-in-lobby"
                      element={<CheckinLobbyScreen />}
                    />
                    <Route path="/feedback" element={<FeedbackScreen />} />
                    <Route
                      path="/patient-feedback"
                      element={<FeedbackResultsScreen />}
                    />
                    <Route
                      path="/secure-files"
                      element={<SecureFilesScreen />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "fileAdmin" ? (
                  <Fragment>
                    <Route
                      path="/users"
                      element={<UsersScreen socket={socket} />}
                    />
                    <Route
                      path="/secure-files"
                      element={<SecureFilesScreen />}
                    />
                  </Fragment>
                ) : userDetails.data?.user.role === "rtmAdmin" ? (
                  <Fragment>
                    <Route path="/rtm-plan" element={<RtmPlan />} />
                    <Route
                      path="/rtm-time-logging"
                      element={<RtmTimeLogging />}
                    />
                    <Route
                      path="/rtm-template"
                      element={<RtmTemplateScreen />}
                    />
                    <Route
                      path="/rtm-resource"
                      element={<ResourcesNewScreen />}
                    />
                    <Route
                      path="/patient"
                      element={<PatientScreen socket={socket} />}
                    />

                    {/* <Route path="/patient" element={<PatientsDashboard />} /> */}
                    <Route
                      path="/plan-patient-list"
                      element={<PlanPatientListScreen />}
                    />
                    {/* <Route path="/billing-list" element={<BillingList />} /> */}
                  </Fragment>
                ) : (
                  <Fragment></Fragment>
                )}
              </Fragment>
            )}

            <Route
              path="*"
              element={isAuthenticated ? <HomeScreen /> : <LoginScreen />}
            />
          </Routes>
        </VideoState>
      </SessionTimeoutProvider>
    </HashRouter>
  );
};

export default Navigation;
